import React from 'react';
import Highcharts from 'highcharts';

class QrCodePieChart extends React.Component {
  constructor(props) {
    super(props);
    this.chartRef = React.createRef();
  }

  componentDidMount() {
    const { data, title } = this.props;

    const seriesData = Object.entries(data).map(([name, y]) => ({
      name: name || 'Unknown',
      y: y
    }));

    Highcharts.chart(this.chartRef.current, {
      chart: { type: 'pie' },
      title: { text: title || 'Breakdown' },
      credits: { enabled: false },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: true,
            format: '<b>{point.name}</b>: {point.y} ({point.percentage:.1f}%)'
          }
        }
      },
      series: [{
        name: 'Count',
        data: seriesData
      }],
      tooltip: {
        pointFormat: '<b>{point.y}</b> ({point.percentage:.1f}%)'
      }
    });
  }

  render() {
    return <div ref={this.chartRef} style={{ width: '100%', minHeight: '300px' }} />;
  }
}

export default QrCodePieChart;
